import React from 'react'
import PropTypes from 'prop-types'
import { BaseForm as Form } from 'component/base'

export const KumiaiinTokusei = props => {
  return (
    <Form.Dropdown.WithAPI
      url='/api/staff/master/kumiaiin_tokusei'
      keyName='id'
      valueName='id'
      textName='name'
      {...props}
    />
  )
}

KumiaiinTokusei.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
}

KumiaiinTokusei.defaultProps = {
  name: 'kumiaiin_tokusei',
  label: '組合員特性',
  value: undefined,
}
